// Проверяем наличие sessionStorage ключа для бандла
if (!sessionStorage.getItem('bundle')) {
  sessionStorage.setItem('bundle', JSON.stringify([]));
}

// Функция для отображения текущего содержимого бандла
const renderBundle = () => {
  const bundle = JSON.parse(sessionStorage.getItem('bundle'));
  const bundlesBlock = document.getElementById('bundles-block');
  const bundlesBack = document.querySelector('.bundles__back'); // Получаем элемент для добавления класса

  if (bundlesBlock) {
    if (bundle.length > 0) {
      bundlesBlock.innerHTML = bundle
        .map(({ variantId, imageSrc }, index) => 
          `<div data-index="${index}" class="bundle-item">
            <img src="${imageSrc}" alt="Product Image">
            <span class="remove-item" style="cursor: pointer;">
              <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.528687 0.52866C0.653706 0.403679 0.823244 0.333469 1.00002 0.333469C1.1768 0.333469 1.34634 0.403679 1.47135 0.52866L4.00002 3.05733L6.52869 0.52866C6.59018 0.464986 6.66375 0.414198 6.74508 0.379259C6.82642 0.34432 6.9139 0.325929 7.00242 0.325159C7.09094 0.32439 7.17872 0.341258 7.26066 0.374778C7.34259 0.408299 7.41702 0.457801 7.47962 0.520396C7.54221 0.582991 7.59171 0.657426 7.62523 0.739357C7.65876 0.821288 7.67562 0.909074 7.67485 0.997594C7.67408 1.08611 7.65569 1.17359 7.62075 1.25493C7.58581 1.33627 7.53503 1.40983 7.47135 1.47133L4.94269 3.99999L7.47135 6.52866C7.59279 6.65439 7.65999 6.8228 7.65847 6.99759C7.65695 7.17239 7.58684 7.3396 7.46323 7.4632C7.33963 7.58681 7.17242 7.65692 6.99762 7.65844C6.82282 7.65996 6.65442 7.59277 6.52869 7.47133L4.00002 4.94266L1.47135 7.47133C1.34562 7.59277 1.17722 7.65996 1.00242 7.65844C0.827622 7.65692 0.660413 7.58681 0.536808 7.4632C0.413203 7.3396 0.34309 7.17239 0.341571 6.99759C0.340052 6.8228 0.407248 6.65439 0.528687 6.52866L3.05735 3.99999L0.528687 1.47133C0.403706 1.34631 0.333496 1.17677 0.333496 0.999993C0.333496 0.823217 0.403706 0.653678 0.528687 0.52866Z" fill="white"/>
              </svg>
            </span>
          </div>`
        )
        .join('');
    } else {
      bundlesBlock.innerHTML = '';
    }

    // Добавляем обработчики для кнопок удаления
    const removeButtons = bundlesBlock.querySelectorAll('.remove-item');
    removeButtons.forEach(button => {
      button.addEventListener('click', function () {
        const parentDiv = this.closest('.bundle-item');
        const indexToRemove = parentDiv.getAttribute('data-index');

        // Удаляем элемент из sessionStorage
        const bundle = JSON.parse(sessionStorage.getItem('bundle'));
        bundle.splice(indexToRemove, 1); // Удаляем по индексу
        sessionStorage.setItem('bundle', JSON.stringify(bundle));

        // Обновляем отображение
        renderBundle();
      });
    });
  }

  // Назначаем класс на bundles__back в зависимости от количества продуктов
  if (bundlesBack) {
    bundlesBack.classList.remove('active-0', 'active-1', 'active-2', 'active-3', 'active-4'); // Сначала удаляем все возможные классы
    bundlesBack.classList.add(`active-${bundle.length}`); // Добавляем класс в зависимости от длины бандла
  }

  // Проверяем, если в бандле больше 4 продуктов
  if (bundle.length > 4) {
    addToCart(bundle);
  }
};

// Функция добавления продуктов в корзину
const addToCart = (bundle) => {
  const items = bundle.map(({ variantId }) => ({
    id: variantId, 
    quantity: 1,
  }));

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ items }),
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to add items to the cart');
      }
      return response.json();
    })
    .then(() => {
      // Очистка sessionStorage
      sessionStorage.setItem('bundle', JSON.stringify([]));

      // Обновляем отображение бандла
      renderBundle();

      // Обновляем cart drawer
      const cartDrawer = document.querySelector('cart-drawer-items');
      if (cartDrawer) {
        cartDrawer.onCartUpdate();
      }
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.click();
      }
    })
    .catch(error => {
      console.error('Error adding items to the cart:', error);
    });
};

// Обработчик для кнопок добавления в бандл
const setupAddToBundleButtons = () => {
  const addToBundleButtons = document.querySelectorAll('.js-add-to-bunble');

  addToBundleButtons.forEach(button => {
    button.addEventListener('click', function () {
      const form = this.closest('form');
      const quickAddModal = this.closest('quick-add-modal');      
      const button = this; // Для использования ниже

      if (form && quickAddModal) {        
        const variantInput = form.querySelector('.product-variant-id');
        const variantQuantity = parseInt(variantInput.getAttribute('js-variant-quantity'), 10);
        const swiperSlide = quickAddModal.querySelector('.swiper-slide img');

        if (variantInput && swiperSlide) {
          const variantId = variantInput.value;          
          const imageSrc = swiperSlide.src;

          // Проверяем наличие и количество варианта в бандле
          const bundle = JSON.parse(sessionStorage.getItem('bundle'));
          const currentCount = bundle.filter(item => item.variantId === variantId).length;

          if (currentCount >= variantQuantity) {
            // Выводим сообщение, если лимит достигнут
            const message = document.createElement('div');
            message.textContent = 'Sorry, this was the last item of this variant in stock.';
            message.style.color = 'red';
            message.style.marginBottom = '10px';
            button.parentElement.insertBefore(message, button);

            // Убираем сообщение через 3 секунды
            setTimeout(() => {
              message.remove();
            }, 3000);
            return;
          }

          // Добавляем объект с variantId и imageSrc в sessionStorage
          bundle.push({ variantId, imageSrc });
          sessionStorage.setItem('bundle', JSON.stringify(bundle));

          // Обновляем отображение бандла
          renderBundle();

          // Инициируем клик по элементу с классом quick-add-modal__toggle
          const closeButton = quickAddModal.querySelector('.quick-add-modal__toggle');
          if (closeButton) {
            closeButton.click();
          } else {
            console.error('Элемент с классом quick-add-modal__toggle не найден');
          }
        } else {
          console.error('Не удалось найти variantId или изображение продукта');
        }
      } else {
        console.error('Форма или модальное окно quick-add-modal не найдены');
      }
    });
  });
};

// Изначально отображаем содержимое бандла
renderBundle();
setupAddToBundleButtons();




// Определение custom element
if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(`${opener.getAttribute('data-product-url')}?view=quick-add-modal`)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);

            // Устанавливаем обработчики для кнопок в модальном окне
            setupAddToBundleButtons();

            // Обновляем отображение бандла (на случай, если в модальном окне есть bundles-block)
            renderBundle();
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');

            const QuickAddSlider = new Swiper(".js-quick-add-slider-init", {
              pagination: {
                el: ".js-quick-add-slider-pagination",
              },
            });
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
